// Shared frontend configuration constants.

// Credit balance (in USD) at or below which the advertiser is warned that
// their credits are running low. Overridable per-environment via
// REACT_APP_LOW_CREDIT_THRESHOLD without a code change.
export const LOW_CREDIT_THRESHOLD = Number(
  process.env.REACT_APP_LOW_CREDIT_THRESHOLD ?? 10
);
